import config from './configureStore'

const store = config.configureStore()

export default store



// WEBPACK FOOTER //
// ./src/store/index.js